import { render, staticRenderFns } from "./CnabReturnSendFile.vue?vue&type=template&id=4b368bb0"
import script from "./CnabReturnSendFile.vue?vue&type=script&lang=js"
export * from "./CnabReturnSendFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports